import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import { customPalette, fontSize } from "shared/palettes/constant";

const CustomTheme = (props) => {
  const { children } = props;

  const theme = createTheme({
    typography: {
      fontFamily: ["Prompt"].join(","),
    },
    palette: {
      primary: {
        main: customPalette.primary,
      },
      secondary: {
        main: customPalette.secondary,
      },
      outlined: {
        main: customPalette.black,
        backgroundColor: customPalette.white,
        color: customPalette.black,
      },
      default: {
        main: customPalette.default,
      },
    },
    components: {
      MuiButton: {
        variants: [
          {
            props: { variant: "contained", color: "primary" },
            style: {
              backgroundColor: customPalette.primary,
              ":hover": {
                backgroundColor: customPalette.hover,
                boxShadow:
                  "0 2px 8px 0 rgba(0,0,0,0.2), 0 2px 8px 0 rgba(0,0,0,0.2)",
              },
              ":focus": {
                backgroundColor: customPalette.primary,
              },
              ":active": {
                backgroundColor: customPalette.primary,
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            },
          },
          {
            props: { variant: "contained", color: "secondary" },
            style: {
              backgroundColor: customPalette.secondary,
              color: customPalette.black,
              ":focus": {
                backgroundColor: customPalette.secondary,
              },
              ":active": {
                backgroundColor: customPalette.secondary,
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            },
          },
          {
            props: { variant: "contained", color: "warning" },
            style: {
              backgroundColor: customPalette.warning,
              color: customPalette.black,
              ":focus": {
                backgroundColor: customPalette.warning,
              },
              ":active": {
                backgroundColor: customPalette.warning,
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            },
          },
          {
            props: { variant: "contained", color: "error" },
            style: {
              backgroundColor: customPalette.error,
              color: customPalette.default,
              ":focus": {
                backgroundColor: customPalette.error,
              },
              ":active": {
                backgroundColor: customPalette.error,
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            },
          },
          {
            props: { variant: "contained", color: "default" },
            style: {
              backgroundColor: customPalette.default,
              color: customPalette.black,
              ":focus": {
                backgroundColor: customPalette.default,
              },
              ":active": {
                backgroundColor: customPalette.default,
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
                color: "rgba(0, 0, 0, 0.26)",
              },
            },
          },
          {
            props: { variant: "outlined", color: "primary" },
            style: {
              color: customPalette.primary,
            },
          },
          {
            props: { variant: "outlined", color: "error" },
            style: {
              color: customPalette.error,
            },
          },
          {
            props: { variant: "outlined", color: "warning" },
            style: {
              color: customPalette.error,
            },
          },
        ],
        styleOverrides: {
          root: {
            color: customPalette.default,
          },
        },
      },
      MuiTypography: {
        variants: [
          {
            props: { size: "large" },
            style: {
              fontSize: fontSize.large,
            },
          },
          {
            props: { size: "medium" },
            style: {
              fontSize: fontSize.medium,
            },
          },
          {
            props: { size: "small" },
            style: {
              fontSize: fontSize.small,
            },
          },
        ],
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default CustomTheme;
